import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isBlank } from 'helpers/string_helpers';

export class TitleBar extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    imageUrl: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    whiteTitle: PropTypes.bool
  };

  render() {
    const headerClass = classNames({
      "page-header": true,
      "with-image": !isBlank(this.props.imageUrl),
      "white": this.props.whiteTitle
    });

    const titleClass = classNames({
      "h2": true,
      "with-border": !isBlank(this.props.subtitle)
    });

    return (
      <div className={headerClass}>
        <div className="container">
          <div className="title-bar">
            <div>
              {this.renderImage()}
            </div>
            <span className={titleClass}>
              {this.props.title}
            </span>
            {this.renderSubtitle()}
            {this.renderRightSection()}
          </div>
        </div>
      </div>
    );
  }

  renderImage() {
    if (!isBlank(this.props.imageUrl)) {
      return (
        <img className="visible-lg-inline visible-md-inline" src={this.props.imageUrl} />
      );
    }
  }

  renderSubtitle() {
    if (!isBlank(this.props.subtitle)) {
      return (
        <h4 className="visible-lg-inline visible-md-inline">
          {this.props.subtitle}
        </h4>
      );
    }
  }

  renderRightSection() {
    if (this.props.children) {
      return (
        <div className="pull-right">
          {this.props.children}
        </div>
      );
    }
  }
}

export default TitleBar;
